// StatusDot — the spec's status language: small colored dot + concise 12px/500 label.
// Replaces the capsule/pill treatment. Color is never the only signal (label always present).
import React from 'react';
import { tokens } from '../theme';

const STATUS_COLORS = {
  RTC: '#3B82F6', IOP: '#7C3AED', PHP: '#0EA5E9', DTX: '#F59E0B', SL: '#0D9488',
  'SOBER LIVING': '#0D9488', MEDS: tokens.success, ALERT: tokens.danger,
  INTAKE: tokens.warning, AUTH: '#F97316',
};

export default function StatusDot({ label, color, style }) {
  const c = color || STATUS_COLORS[String(label || '').toUpperCase()] || tokens.textMuted;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6,
      fontSize: 12, fontWeight: 500, color: tokens.ink, fontFamily: tokens.font,
      whiteSpace: 'nowrap', ...style }}>
      <span style={{ width: 8, height: 8, borderRadius: '50%', background: c, flex: 'none' }} />
      {label || '\u2014'}
    </span>
  );
}
